// © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED

import React, { memo } from 'react';
import { IconProps as Props } from '../types';

const SvgSpotify: React.FC<Props> = (allProps) => {
  const { fill, primary, secondary, tertiary, quaternary, title, ...props } = allProps;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      focusable="false"
      role="img"
      {...props}
    >
      <title>{title}</title>
      <g fill={primary ?? fill ?? 'currentColor'}>
        <path d="M12.476.01C5.853-.254.272 4.9.01 11.524c-.264 6.623 4.893 12.203 11.514 12.466 6.623.264 12.203-4.891 12.466-11.514C24.253 5.853 19.098.272 12.476.01m5.065 17.58a.716.716 0 0 1-.977.268 14.396 14.396 0 0 0-5.138-1.747 14.37 14.37 0 0 0-5.42.263.716.716 0 1 1-.338-1.393 15.802 15.802 0 0 1 5.958-.29c2.003.282 3.902.928 5.647 1.921a.718.718 0 0 1 .27.977zm1.577-3.15a.932.932 0 0 1-1.262.376 17.685 17.685 0 0 0-5.972-1.96 17.688 17.688 0 0 0-6.28.238.93.93 0 1 1-.4-1.82 19.544 19.544 0 0 1 6.94-.263 19.524 19.524 0 0 1 6.598 2.165.93.93 0 0 1 .376 1.262zm1.749-3.552a1.147 1.147 0 0 1-1.547.488 21.389 21.389 0 0 0-6.917-2.208 21.415 21.415 0 0 0-7.26.216 1.146 1.146 0 0 1-.455-2.246 23.718 23.718 0 0 1 8.034-.24c2.688.378 5.263 1.2 7.656 2.446.562.291.78.983.489 1.545z" />
      </g>
    </svg>
  );
};

const Memo = memo(SvgSpotify);
export default Memo;
